import axios from 'axios'

const BASE_URL = process.env.VISIT_NG_CHECK_API
const LOGIN = BASE_URL + '/login'
const ADDRESSES = BASE_URL + '/addresses'
const ACCOUNTS = BASE_URL + '/accounts'

function authorizationHeaders (token) {
  return {headers: {Authorization: token}}
}

/**
 * ログイン
 * @param user
 * @param password
 * @returns {AxiosPromise<any>}
 */
function login (user, password) {
  return axios.post(LOGIN, {
    user: user,
    password: password
  })
}

/**
 * 住所一覧データを取得する
 * @param token
 * @returns {AxiosPromise<any>}
 */
export function getAddresses (token) {
  return axios.get(ADDRESSES, authorizationHeaders(token))
}

/**
 * CSV住所データを登録する
 * @param token
 * @param file
 * @returns {AxiosPromise<any>}
 */
export function postAddresses (token, file) {
  const headers = authorizationHeaders(token)
  headers.headers['Content-Type'] = 'application/octet-stream'
  return axios.post(ADDRESSES, file, headers)
}

export function postAccounts (token, file) {
  const headers = authorizationHeaders(token)
  headers.headers['Content-Type'] = 'application/octet-stream'
  return axios.post(ACCOUNTS, file, headers)
}

const api = {
  login: login,
  getAddresses: getAddresses,
  postAddresses: postAddresses
}

export default api



// WEBPACK FOOTER //
// ./src/lib/api.js